import { Controller } from '@hotwired/stimulus';

export class AddressController extends Controller {
  static targets = [
    'country',
    'regionField',
    'regionTemplate',
    'provinceTemplate',
    'stateTemplate',
  ];

  updateRegionField(event) {
    let template;

    switch (event.target.value) {
    case 'US':
      template = this.stateTemplateTarget;
      break;
    case 'CA':
      template = this.provinceTemplateTarget;
      break;
    default:
      template = this.regionTemplateTarget;
      break;
    }

    this.regionFieldTarget.innerHTML = template.innerHTML;
  }
}
